import { getAppEnvironment } from '@moodys/cre-cpm.functions.environment';

export const getTestId = (id: string | number, custom?: string | number): string | undefined => (getAppEnvironment() !== 'production'
  ? `${id.toString().replace(/\s/g, '-')}${id && custom ? '--' : ''}${id ? custom?.toString().replace(/\s/g, '-') ?? '' : ''}`
  : undefined) || undefined;
